import type { CommonFormErrorEnum } from "@/utils/form";

export const keyForError = <ErrorEnum extends CommonFormErrorEnum>(
  module: string,
  field: string,
  error: ErrorEnum
): string => {
  return `${module}.errors.${field}.${error}`;
};
